var MANULIFE_ICON_SIZE_DEFAULT = 20;
var SVG_ICON_SIZE_DEFAULT = 20;

export { MANULIFE_ICON_SIZE_DEFAULT, SVG_ICON_SIZE_DEFAULT };
